import { FC } from 'react';

const NotFound: FC = () => (
  <div>
    <h1>Page not found</h1>
  </div>
);

export default NotFound;
